module.exports = __webpack_public_path__ + "img/w24.81a9ab0f.svg";